import styled from 'styled-components';
import chroma from 'chroma-js';

import UserLogoIcon from 'js/components/core/Icons/UserLogoIcon';

const color = chroma('#444');

export default styled(UserLogoIcon)`
  max-width: 100%;
  max-height: 100%;
  user-select: none;
  align-self: start;
  justify-self: center;

  .background {
    fill: ${color};
  }

  &:hover {
    .background {
      fill: ${color.darken()};
    }
  }
`;
